import React, { useEffect, useState } from "react";
import logo from "../../../assets/logo/motickets_logo.png";
// import { MdArrowDropDown } from "react-icons/md";
// import { useCountries, Country } from "../../../constant/useCountries";
// import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../../../redux/api/authApi";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { countries } from "countries-list";

type Props = {};

interface LoginError {
  error: boolean;
  message: string;
}

const Register = (props: Props) => {
  // Move the United Kingdom to the first position
  const countriesList = Object.values(countries);
  const ukIndex = countriesList.findIndex(
    (country) => country.name === "United Kingdom"
  );
  if (ukIndex !== -1) {
    const [ukCountry] = countriesList.splice(ukIndex, 1);
    countriesList.unshift(ukCountry);
  }

  const navigate = useNavigate();

  const [user, setUser] = useState({
    fullname: "",
    email: "",
    country: "United Kingdom", // Set the default country to United Kingdom
    password: "",
  });
  const { fullname, email, country, password } = user;
  const [register, { isLoading, error, data }] = useRegisterMutation();

  console.log(data);

  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (error) {
      if ("data" in error) {
        const errorMessage =
          (error as FetchBaseQueryError & { data: LoginError }).data.message ||
          "Unknown error";
        toast.error(errorMessage);
      } else {
        toast.error("An unexpected error occurred.");
      }
    } else if (data) {
      toast.success(data.message);
      navigate("/login");
    }
  }, [error, data, navigate]);

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (error) {
      navigate("/");
      toast.error("Login Failed");
    }

    const signUp = {
      fullname,
      email,
      country,
      password,
    };
    register(signUp);
  };

  const onchange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    if (typeof e.target === "object" && e.target !== null) {
      const { name, value } = e.target;
      setUser({ ...user, [name]: value });
    }
  };

  return (
    <div className="py-16">
      <ToastContainer />

      <div className="flex bg-white rounded-lg shadow-lg overflow-hidden mx-auto max-w-md lg:max-w-7xl">
        <div
          className="hidden md:block lg:w-1/2 bg-cover"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1602345397613-0934a8812d23?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGRldnxlbnwwfHwwfHx8MA%3D%3D')",
          }}
        ></div>
        <div className="w-full p-8 lg:w-1/2 md:1/12">
          <h2 className="text-2xl font-semibold text-gray-700 text-center">
            <img src={logo} alt="Motickets logo" />
          </h2>
          <p className="text-xl text-gray-600 text-center">Welcome back!</p>

          <div className="mt-4 flex items-center justify-between">
            <span className="border-b w-1/5 lg:w-1/4"></span>
            <Link
              to="#"
              className="text-xs text-center text-gray-500 uppercase"
            >
              or login with email
            </Link>
            <span className="border-b w-1/5 lg:w-1/4"></span>
          </div>
          <form onSubmit={submitHandler}>
            <div className="mt-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Full name
              </label>
              <input
                className="bg-gray-200 text-gray-700 focus:outline-none focus:shadow-outline border border-gray-300 rounded py-2 px-4 block w-full appearance-none"
                type="name"
                name="fullname"
                value={fullname}
                onChange={onchange}
              />
            </div>

            <div className="mt-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Email Address
              </label>
              <input
                className="bg-gray-200 text-gray-700 focus:outline-none focus:shadow-outline border border-gray-300 rounded py-2 px-4 block w-full appearance-none"
                type="email"
                name="email"
                value={email}
                onChange={onchange}
              />
            </div>
            <div className="mt-4 relative">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Country
              </label>
              <div
                className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                onClick={() => setShowDropdown(!showDropdown)}
              ></div>
              <select
                onClick={() => setShowDropdown(!showDropdown)}
                className="pl-8 pr-10 bg-gray-200 text-gray-700 focus:outline-none focus:shadow-outline border border-gray-300 rounded py-2 px-4 block w-full appearance-none"
                name="country"
                onChange={onchange}
                value={country} // Ensure the selected value is reflected
              >
                {countriesList?.map((country) => (
                  <option key={country?.name} value={country?.name}>
                    {country?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-4">
              <div className="flex justify-between">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Password
                </label>
              </div>
              <input
                className="bg-gray-200 text-gray-700 focus:outline-none focus:shadow-outline border border-gray-300 rounded py-2 px-4 block w-full appearance-none"
                type="password"
                name="password"
                value={password}
                onChange={onchange}
              />
            </div>

            <div className="mt-8">
              <button
                type="submit"
                className="bg-[#25aae1] text-white font-bold py-3 px-4 w-full rounded disabled:opacity-70 disabled:cursor-not-allowed"
                disabled={isLoading}
              >
                {isLoading ? "Creating" : "Sign up"}
              </button>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <span className="border-b w-1/5 md:w-1/4"></span>
              <Link to="/login" className="text-xs text-gray-500 uppercase">
                or sign in
              </Link>
              <span className="border-b w-1/5 md:w-1/4"></span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
